<template>
  <role-form
    ref="formComponent"
    action-type="edit"
    :role="role"
    :has-permissions-permission="
      userHasManagementPermission('client_role_permission_store') &&
        userHasManagementPermission('client_role_permission_destroy')
    "
    :has-companies-permission="
      userHasManagementPermission('company_permission_store') &&
        userHasManagementPermission('company_permission_destroy')
    "
    :has-users-permission="
      userHasManagementPermission('user_permission_store') &&
        userHasManagementPermission('user_permission_destroy')
    "
    :loading="loading"
    :submission-error="submissionError"
    :previousRolesAndPermissions="previousRolesAndPermissions"
    @update-fields-validity="fieldsAreValid = $event"
    @update-field="updateFieldValue"
    @save="editRole"
  />
</template>

<script>
import RoleForm from "@/components/SystemManagement/Accounts/ClientRoles/ClientRoleForm";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mapActions } from "vuex";
import { clientRoleMixin } from "@/mixins/management/clientRoleMixin";
export default {
  name: "RoleEdit",

  components: { RoleForm },

  mixins: [checkPermissionsMixin, clientRoleMixin],

  data() {
    return {
      /**
       * Data that was changed while editing the client role
       */
      editedRole: {},

      fieldsAreValid: true,
      submissionError: null,

      /**
       * Define if the page is loading
       */
      loading: true
    };
  },

  mounted() {
    this.fetchRoleDataByUuid();
  },

  methods: {
    ...mapActions(["editClientRoleUuid"]),

    /**
     * Updates the value of a specific field of the role object and the editedRole object.
     *
     * @param {Object} data - { fieldName, value }
     */
    updateFieldValue(data) {
      this.role[data.fieldName] = data.value;
      this.editedRole[data.fieldName] = data.value;
    },

    /**
     *  Request the BE to edit the client role.
     *
     * @return {Promise<void>}
     * @success - Return to previous page
     * @error - Set the value of the submissionError variable
     */
    async editRole() {
      if (this.fieldsAreValid) {
        try {
          this.loading = true;
          let dataToSend = this.prepareDataToSend();
          await this.editClientRoleUuid({
            uuid: this.$route.params.uuid,
            updatedData: dataToSend
          });
          this.$router.back();
          this.$toasted.global.toast_success(
            this.$i18n.t("RoleEditedSuccessfully")
          );
        } catch (error) {
          this.loading = false;
          this.submissionError = error;
        }
      }
    },

    /**
     * Prepares the data to send the server to edit the client role
     *
     * @return {{companies: [], visible: boolean, blocked: boolean, permissions: [], description: string,
     *           active: boolean, label: string, users: []}}
     */
    prepareDataToSend() {
      let dataToSend = Object.assign({}, this.editedRole);

      if (this.editedRole.permissions) {
        if (this.editedRole.permissions.length > 0) {
          dataToSend.permissions = this.$refs.formComponent.prepareListOfIDsToSend(
            this.role.permissions
          );
        } else {
          dataToSend.permissions = [{ delete_all: true }];
        }
      }

      dataToSend.users = this.role.usersWebAssociates.concat(
        this.role.usersMobileAssociates
      );
      delete dataToSend.usersWebAssociates;
      delete dataToSend.usersMobileAssociates;

      if (dataToSend.users.length > 0) {
        dataToSend.users = this.$refs.formComponent.prepareListOfObjectsToSend(
          dataToSend.users
        );
      } else {
        dataToSend.users = [{ delete_all: true }];
      }

      if (this.editedRole.companies) {
        if (this.editedRole.companies.length > 0) {
          dataToSend.companies = this.$refs.formComponent.prepareListOfObjectsToSend(
            this.role.companies
          );
        } else {
          dataToSend.companies = [{ delete_all: true }];
        }
      }

      dataToSend.active = this.role.active;
      dataToSend.label = this.role.label;

      return dataToSend;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/Accounts/ClientRoles/ClientRoleEdit.vue